import React, { Fragment } from 'react';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import Spinner from 'react-spinkit';
import { usePaystackPayment, PaystackButton, PaystackConsumer } from 'react-paystack';

import Header from '../components/header';
import { calcTotalPrice } from '../utils/utils';

const USER_CART_ITEMS = gql`
  query CART{
    cart{
      id
      quantity
      product{
        name
        image_url
        price
      }
    }
  }
`;
const REMOVE_ITEM_FROM_CART = gql`
  mutation REMOVE_ITEM_FROM_CART($cartId: String) {
    removeFromCart(cartId: $cartId) {
      id,
      quantity
      product{
        name
        price
        image_url
      }
    }
  }
`;
const Cart = (props) => {

  const [removeFromCart] = useMutation(REMOVE_ITEM_FROM_CART);

  const removeCartItem = async (cartId) => {

    try {
      const response = await removeFromCart({
        variables: {
          cartId
        },
        update: (cache, { data: { removeFromCart } }) => {
          const data = cache.readQuery({ query: USER_CART_ITEMS });
          const index = data.cart.findIndex(item => {
            return item.id === removeFromCart.id;
          });

          if (index > -1) {
            data.cart.splice(index, 1);
          }
          cache.writeQuery({ query: USER_CART_ITEMS, data });
        }
      });
    } catch (error) {
      console.log(error.message);
    }
  }

  const { loading, error, data } = useQuery(USER_CART_ITEMS);

  if (loading) return (<Spinner name="circle" />);
  // if (error) return "ERROR!!!";



  return (
    <Fragment>
      <Header />
        <section className="cart">
          <div className="cart__card">
            <table>
              <thead>
                <tr>
                  <th className="im">image</th>
                  <th>Name</th>
                  <th>price</th>
                  <th>Remove</th>
                </tr>
              </thead>
            {
                data.cart.length > 0 ? data.cart.map(item => {
                  return (
                    <tbody>
                      <tr>
                        <td><img className="cart__card__image" src={item.product.image_url} alt={item.name} /></td>
                        <td>{item.product.name}</td>
                        <td>${item.product.price * item.quantity} - {item.quantity} &times; ${item.product.price} each</td>
                        <th><button onClick={() => removeCartItem(item.id)} className="times">&times;</button></th>
                      </tr>
                    </tbody>
                  )
                }) : 'NO CART ITEM'
              }
              <tr>
                <td colspan="1"></td>
                <th>Total</th>
                <td>${calcTotalPrice(data.cart)}</td>
                {data.cart.length > 0 ? <td><PaystackButton className="btn">Checkout</PaystackButton></td> : ''}
            </tr>
            </table>
          </div>
        </section>
    </Fragment>
  );
}

export default Cart;
export { USER_CART_ITEMS };
